// extracted by mini-css-extract-plugin
export default {"third":"screen_third__G0vnH","info":"screen_info__kQBPD","title":"screen_title__MQXUi","images":"screen_images__J0dyR","subtitle":"screen_subtitle__1RmAr"};